
import { formatDateForDatabase } from "@/hooks/goal-operations/helpers/dateUtils";

/**
 * Formats a date string for display
 */
export function formatDate(dateString: string): string {
  return formatDateForDatabase(dateString) || '';
}

/**
 * Prepares a date for storing in the database
 */
export function prepareDateForDatabase(date: Date | string | undefined | null): string | null {
  return formatDateForDatabase(date);
}
